import React from "react";
import PageContainer from "../../Components/Page/PageContainer";
import EditableDataTable from "../../Components/EditableDataTable/EditableDataTable";
import MusicCMSConsoleDashboard from "../../Components/MusicCMSConsoleDashboard/MusicCMSConsoleDashboard";

const TestPage = () => {
  return (
    <PageContainer HomeMenuBarprops={{ title: "TEST" }}>
      <MusicCMSConsoleDashboard />
      <EditableDataTable />
    </PageContainer>
  );
};

export default TestPage;
